import apiClient from '../middleware/apiClient';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';
import { SSM_BILL_FUTURE_STATEMENT } from '../helpers/apis';
import { COTTON_SSM_BILL_FUTURE_STATEMENT } from '../helpers/cottonApis';

export const GET_BILL_FUTURE_STATEMENT = 'GET_BILL_FUTURE_STATEMENT';
export const GET_BILL_FUTURE_STATEMENT_SUCCESS = 'GET_BILL_FUTURE_STATEMENT_SUCCESS';
export const GET_BILL_FUTURE_STATEMENT_FAILURE = 'GET_BILL_FUTURE_STATEMENT_FAILURE';

function dispatchGetBillFutureStatement(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_SSM_BILL_FUTURE_STATEMENT : SSM_BILL_FUTURE_STATEMENT;
  return {
    type: GET_BILL_FUTURE_STATEMENT,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetBillFutureStatementSuccess(statement) {
  return {
    type: GET_BILL_FUTURE_STATEMENT_SUCCESS,
    payload: statement,
  };
}

function dispatchGetBillFutureStatementFailure() {
  return {
    type: GET_BILL_FUTURE_STATEMENT_FAILURE,
  };
}

export const getBillFutureStatement = (options = {}) => async (dispatch, getState) => {
  const { statement: { cached } = {} } = getState();
  if (cached && !options.force) {
    return null;
  }

  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(dispatchGetBillFutureStatement(isCottonSession)).payload;
    return dispatch(dispatchGetBillFutureStatementSuccess(response));
  } catch (error) {
    dispatch(dispatchGetBillFutureStatementFailure());

    return null;
  }
};
